import { Navigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ permissionKey, children }) => {
  const { hasPermission } = usePermissions();
  const ne1Wms = useSelector((state) => state.user?.ne1Wms);

  // const hasAccess = primaryNavigationChecker(permissionKey, role);
  const hasAccess = hasPermission(permissionKey);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (ne1Wms === 0) {
    return <Navigate to="/learnMore" replace />;
  }

  return children;
};

export default ProtectedRoute;
